import { render } from "./Patients.vue?vue&type=template&id=ea2bf48a&ts=true"
import script from "./Patients.ts?vue&type=script&lang=ts&external"
export * from "./Patients.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__